<div class="row">
    <div class="col-md-8">
        <input [ngModel]="searchQuery" #search class="form-control" type="text" placeholder="{{ 'search' | translate }}" (input)="onSearch(search.value)">
    </div>
    <div class="col-md-12 mt-4">
        <h6>{{ 'filterByCustomerCategory' | translate }}</h6>
        <app-customer-categories (customerCategoryChanged)="onCustomerCategoryChanged($event)"></app-customer-categories>
    </div>
</div>
<br>
<ng2-smart-table [settings]="settings" [source]="source"></ng2-smart-table>


// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/components/sites/sites-table/sites-table.component.html